<template>
    <path d="M17.002 10.958l-5.203 5.902c-.165.187-.432.187-.597 0l-5.203-5.902c-.165-.187-.165-.49 0-.676l.689-.78c.169-.19.44-.187.601.008l3.294 3.862V3.477c0-.262.19-.477.422-.477h.984c.232 0 .422.215.422.477v9.895l3.294-3.862c.165-.19.436-.195.6-.008l.69.78c.172.187.172.489.007.676zM18.532 19H4.468c-.258 0-.469.208-.469.462v1.076c0 .254.21.462.469.462H18.53c.258 0 .469-.208.469-.462v-1.076c0-.254-.21-.462-.469-.462z" transform="translate(-593 -473) translate(589 470)"/>
</template>

<script>
export default {
    name: 'downloadIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 15 18');
    }
};
</script>
